import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import Notifications from '@kyvg/vue3-notification'
import Vue3ConfirmDialog from 'vue3-confirm-dialog'
import money from 'v-money'
import VueTheMask from 'vue-the-mask'

import 'vue3-confirm-dialog/style'
import 'vue-loading-overlay/dist/css/index.css'
import 'vue-multiselect/dist/vue-multiselect.css'
import './assets/css/style.css'

const app = createApp(App)

app.use(router)
app.use(Notifications)
app.use(money)
app.use(VueTheMask)
app.use(Vue3ConfirmDialog)
app.component('vue3-confirm-dialog', Vue3ConfirmDialog.default)

app.mount('#app')